export const eventKeys = {
  isGroupEventsKey: (queryKey: readonly unknown[]): boolean => {
    return queryKey[0] === "groupEvents";
  },
  isEventListKey: (queryKey: readonly unknown[]): boolean => {
    const key = queryKey[0];
    return key === "events" || key === "myEvents" || key === "registeredEvents";
  },
  isEventDetailRootKey: (queryKey: readonly unknown[]): boolean => {
    return queryKey[0] === "eventDetail";
  },
  isEventParticipantsRootKey: (queryKey: readonly unknown[]): boolean => {
    return queryKey[0] === "eventParticipants";
  },
};
